import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import request from "../../utils/http";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { Checkbox } from "baseui/checkbox";
import { Spinner } from "baseui/spinner";
import Copy from "../../components/Copy";
import { toaster } from "baseui/toast";

const UserCreate = () => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();

	const [loaded, setLoaded] = useState(false);

	const [id, setId] = useState("");
	const [active, setActive] = useState(false);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [hrTeam, setHrTeam] = useState(false);
	const [opsTeam, setOpsTeam] = useState(false);
	const [payrollTeam, setPayrollTeam] = useState(false);
	const [payrollPilTeam, setPayrollPilTeam] = useState(false);
	const [hrManager, setHrManager] = useState(false);
	const [systemAdmin, setSystemAdmin] = useState(false);

	const createUser = async () => {
		let result = await request("POST", "/api/admin/user/edit", {
			id,
			name,
			hrTeam,
			opsTeam,
			payrollTeam,
			payrollPilTeam,
			hrManager,
			systemAdmin,
			active,
		});
		if (result.success && result.data) {
			const response = result.data;
			if (response.success) {
				navigate({
					pathname: `/users`,
				});
			} else if (response.message) {
				toast("Unable to save: " + response.message, { type: "error" });
			} else {
				toast("Unable to save: " + JSON.stringify(response), {
					type: "error",
				});
			}
		}
	};

	const resetPassword = async () => {
		let result = await request(
			"POST",
			`/api/admin/user/reset-password/${id}`,
			null
		);
		if (result.success && result.data) {
			const response = result.data;
			if (response.success) {
				toast.success("Reset Password");
			} else {
				toast.success("Unable to Reset Password - check with IT Admins");
			}
		}
	};

	const fetchUser = async () => {
		let result = await request(
			"GET",
			`/api/admin/user/${urlParams.userId}`,
			null
		);

		if (result.data) {
			const response = result.data;
			setLoaded(true);
			setId(response.id);
			setName(response.name);
			setEmail(response.email);
			setHrTeam(response.hrTeam);
			setOpsTeam(response.opsTeam);
			setPayrollTeam(response.payrollTeam);
			setPayrollPilTeam(response.payrollPilTeam);
			setHrManager(response.hrManager);
			setSystemAdmin(response.systemAdmin);
			setActive(response.active);
		}
	};

	useEffect(() => {
		fetchUser();
	}, [urlParams.userId]);

	return (
		<>
			<h1>Edit User</h1>
			{!loaded ? (
				<Spinner />
			) : (
				<div>
					<FormControl label={"Name"}>
						<Input
							value={name}
							onChange={(e) => {
								setName(e.currentTarget.value);
							}}
						/>
					</FormControl>
					<FormControl label={"Email"}>
						<>
							<Copy>{email}</Copy>
						</>
					</FormControl>
					<FormControl label={"Is HR Team Member"}>
						<>
							<Checkbox
								key="hrTeam"
								checked={hrTeam}
								onChange={() => {
									setHrTeam(!hrTeam);
								}}
							/>
						</>
					</FormControl>
					<FormControl label={"Is Operation Team Memeber"}>
						<>
							<Checkbox
								key="opsTeam"
								checked={opsTeam}
								onChange={() => {
									setOpsTeam(!opsTeam);
								}}
							/>
						</>
					</FormControl>
					<FormControl label={"Is Payroll Team Member"}>
					<>
						<Checkbox
							key="payrollTeam"
							checked={payrollTeam}
							onChange={() => {
								setPayrollTeam(!payrollTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is PIL Create Team Member"}>
					<>
						<Checkbox
							key="payrollPilTeam"
							checked={payrollPilTeam}
							onChange={() => {
								setPayrollPilTeam(!payrollPilTeam);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is HR Manager"}>
					<>
						<Checkbox
							key="hrManager"
							checked={hrManager}
							onChange={() => {
								setHrManager(!hrManager);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Is System Administrator"}>
					<>
						<Checkbox
							key="systemAdmin"
							checked={systemAdmin}
							onChange={() => {
								setSystemAdmin(!systemAdmin);
							}}
						/>
					</>
				</FormControl>
				<FormControl label={"Active"}>
					<>
						<Checkbox
							key="active"
							checked={active}
							onChange={() => {
								setActive(!active);
							}}
						/>
					</>
				</FormControl>
				<div>
					<Button onClick={createUser}>Save</Button>
					{"   "}
					<Button onClick={resetPassword} kind="tertiary">
						Reset Password
					</Button>
				</div>
				</div>
			)}
		</>
	);
};
export default UserCreate;
